/**
 * TODO: Fetch catalog from SDK.
 * TODO: make sure what is in IAPReward.json always matches this
 * WARNING: these values are also used in tracking
 */
export enum ProductId {
    DEPRECATED_COINS_20k = '001',
    DEPRECATED_COINS_14k = '003',
    DEPRECATED_COINS_35k = '004',
    DEPRECATED_SPECIAL_OFFER = '006',
    DEPRECATED_PRODUCT_7 = '007',
    DEPRECATED_STARTER_PACK_V2 = 'starterpack_v2_0.99',
    DEPRECATED_COINS_240k_V2 = '240000coins_v2_14.99',
    DEPRECATED_SUNDAY_OFFER_V1 = 'sunday_offer_29.99',

    COINS_60k = '002',
    SPECIAL_OFFER = '005',
    STARTER_PACK_V3 = 'starterpack_v3_1.99',
    JOKER_DEAL_V2 = 'jokerdeal_v2_19.99',
    COINS_1mil_V2 = '1000000coins_v2_44.99',
    COINS_10K = '10000coins_0.99',
    COINS_120K = '120000coins_8.99',
    SUNDAY_OFFER_V2 = 'sunday_offer_v2_34.99',
    SUNDAY_OFFER_V2_44_99 = 'sunday_offer2_44.99',
    SUNDAY_OFFER_3_9_99 = 'sunday_offer3_9.99',
    PAYER_REACTIVATION_OFFER = 'reactivation_offer_14.99',
    PAYER_REACTIVATION_OFFER_2 = 'reactivation_offer_2_24.99',
    PAYER_REACTIVATION_OFFER_3 = 'reactivation_offer_3_34.99',
    PREMIUM_SPIN = 'premium_spin_1.99',
    FARM_UNLOCK_AREA = 'slot_unlock1_1.99',
    XMAS_2021_OFFER = 'event_offer_9.99',
    EASTER_2022_OFFER = 'easter2022_event_offer_24.99',
    JUL4_2022_OFFER = 'independence_day_event_offer_24.99',
    HALLOWEEN_2022_OFFER = 'halloween_2022_event_offer_24.99',
    XMAS_2022_OFFER_1 = 'christmas2022_event_offer_4.99',
    XMAS_2022_OFFER_2 = 'christmas2022_event_offer_14.99',

    PLINKO_TOKEN = 'plinko_tokens_0.99',
    PLINKO_TOKENS_2_99 = 'plinko_tokens_2.99',

    VALENTINES_2023_v1_1 = 'valentines_2023_offer_v1.1_1.99',
    VALENTINES_2023_v1_2 = 'valentines_2023_offer_v1.2_1.99',
    VALENTINES_2023_v1_3 = 'valentines_2023_offer_v1.3_1.99',
    VALENTINES_2023_v2_1 = 'valentines_2023_offer_v2.1_4.99',
    VALENTINES_2023_v2_2 = 'valentines_2023_offer_v2.2_4.99',
    VALENTINES_2023_v2_3 = 'valentines_2023_offer_v2.3_4.99',
    VALENTINES_2023_v3_1 = 'valentines_2023_offer_v3.1_14.99',
    VALENTINES_2023_v3_2 = 'valentines_2023_offer_v3.2_14.99',
    VALENTINES_2023_v3_3 = 'valentines_2023_offer_v3.3_14.99',

    BLACKFRIDAY_2023_v1_1 = 'blackfriday_2023_offer_nonspender_1',
    BLACKFRIDAY_2023_v1_2 = 'blackfriday_2023_offer_nonspender_2',
    BLACKFRIDAY_2023_v1_3 = 'blackfriday_2023_offer_nonspender_3',
    BLACKFRIDAY_2023_v2_1 = 'blackfriday_2023_offer_spender_1',
    BLACKFRIDAY_2023_v2_2 = 'blackfriday_2023_offer_spender_2',
    BLACKFRIDAY_2023_v2_3 = 'blackfriday_2023_offer_spender_3',
    BLACKFRIDAY_2023_v3_1 = 'blackfriday_2023_offer_bigspender_1',
    BLACKFRIDAY_2023_v3_2 = 'blackfriday_2023_offer_bigspender_2',
    BLACKFRIDAY_2023_v3_3 = 'blackfriday_2023_offer_bigspender_3',

    XMAS_2023_v1 = 'xmas_2023_offer_nonspender',
    XMAS_2023_v2 = 'xmas_2023_offer_spender',
    XMAS_2023_v3 = 'xmas_2023_offer_bigspender',

    VALENTINES_2024_v1_1 = 'valentines_2024_offer_nonspender_1',
    VALENTINES_2024_v1_2 = 'valentines_2024_offer_nonspender_2',
    VALENTINES_2024_v1_3 = 'valentines_2024_offer_nonspender_3',
    VALENTINES_2024_v2_1 = 'valentines_2024_offer_spender_1',
    VALENTINES_2024_v2_2 = 'valentines_2024_offer_spender_2',
    VALENTINES_2024_v2_3 = 'valentines_2024_offer_spender_3',
    VALENTINES_2024_v3_1 = 'valentines_2024_offer_bigspender_1',
    VALENTINES_2024_v3_2 = 'valentines_2024_offer_bigspender_2',
    VALENTINES_2024_v3_3 = 'valentines_2024_offer_bigspender_3',

    EASTER_2024_v1 = 'easter_2024_offer_nonspender',
    EASTER_2024_v2 = 'easter_2024_offer_spender',
    EASTER_2024_v3 = 'easter_2024_offer_bigspender',
}
